/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  DeleteFileSharingFileAttachmentParams,
  FileSharingAttachmentRequestInput,
  FileSharingFile,
  FileSharingFileRequestInput,
  GetFileSharingFileParams,
  PaginatedFileSharingFiles,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Files
 */
export const listFileSharingFiles = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedFileSharingFiles>(
      {url: `/file_sharing/files`, method: 'GET', signal
    },
      );
    }




export const getListFileSharingFilesQueryKey = () => {
    return [
    'file_sharing','files'
    ] as const;
    }


export const getListFileSharingFilesQueryOptions = <TData = Awaited<ReturnType<typeof listFileSharingFiles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSharingFiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFileSharingFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFileSharingFiles>>> = ({ signal }) => listFileSharingFiles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFileSharingFiles>>, TError, TData>
}

export type ListFileSharingFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listFileSharingFiles>>>
export type ListFileSharingFilesQueryError = ErrorType<void>


/**
 * @summary List of Files
 */

export function useListFileSharingFiles<TData = Awaited<ReturnType<typeof listFileSharingFiles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSharingFiles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFileSharingFilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary File Details
 */
export const getFileSharingFile = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetFileSharingFileParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<FileSharingFile>(
      {url: `/file_sharing/files/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetFileSharingFileQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetFileSharingFileParams>,) => {
    return [
    'file_sharing','files',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFileSharingFileQueryOptions = <TData = Awaited<ReturnType<typeof getFileSharingFile>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetFileSharingFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileSharingFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetFileSharingFileQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileSharingFile>>> = ({ signal }) => getFileSharingFile(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFileSharingFile>>, TError, TData>
}

export type GetFileSharingFileQueryResult = NonNullable<Awaited<ReturnType<typeof getFileSharingFile>>>
export type GetFileSharingFileQueryError = ErrorType<void>


/**
 * @summary File Details
 */

export function useGetFileSharingFile<TData = Awaited<ReturnType<typeof getFileSharingFile>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetFileSharingFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileSharingFile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFileSharingFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update File
 */
export const updateFileSharingFile = (
    id: MaybeRefOrGetter<string>,
    fileSharingFileRequestInput: MaybeRefOrGetter<FileSharingFileRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fileSharingFileRequestInput = toValue(fileSharingFileRequestInput);

      return axiosClient<FileSharingFile>(
      {url: `/file_sharing/files/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fileSharingFileRequestInput, signal
    },
      );
    }




export const getUpdateFileSharingFileMutationKey = () => ['updateFileSharingFile'] as const;

export const getUpdateFileSharingFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFileSharingFile>>, TError,UpdateFileSharingFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFileSharingFile>>, TError,UpdateFileSharingFileMutationVariables, TContext> => {

const mutationKey = getUpdateFileSharingFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFileSharingFile>>, UpdateFileSharingFileMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateFileSharingFile(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFileSharingFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateFileSharingFile>>>
    export type UpdateFileSharingFileMutationBody = FileSharingFileRequestInput
    export type UpdateFileSharingFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateFileSharingFileMutationVariables = {id: string;data: FileSharingFileRequestInput}

    /**
 * @summary Update File
 */
export const useUpdateFileSharingFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFileSharingFile>>, TError,UpdateFileSharingFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFileSharingFile>>,
        TError,
        UpdateFileSharingFileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFileSharingFileMutationOptions(options), queryClient);
    }
    /**
 * @summary Create File Attachement
 */
export const createFileSharingFileAttachment = (
    id: MaybeRefOrGetter<string>,
    fileSharingAttachmentRequestInput: MaybeRefOrGetter<FileSharingAttachmentRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fileSharingAttachmentRequestInput = toValue(fileSharingAttachmentRequestInput);

      return axiosClient<void>(
      {url: `/file_sharing/files/${id}/attachment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fileSharingAttachmentRequestInput, signal
    },
      );
    }




export const getCreateFileSharingFileAttachmentMutationKey = () => ['createFileSharingFileAttachment'] as const;

export const getCreateFileSharingFileAttachmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFileSharingFileAttachment>>, TError,CreateFileSharingFileAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFileSharingFileAttachment>>, TError,CreateFileSharingFileAttachmentMutationVariables, TContext> => {

const mutationKey = getCreateFileSharingFileAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFileSharingFileAttachment>>, CreateFileSharingFileAttachmentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createFileSharingFileAttachment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFileSharingFileAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createFileSharingFileAttachment>>>
    export type CreateFileSharingFileAttachmentMutationBody = FileSharingAttachmentRequestInput
    export type CreateFileSharingFileAttachmentMutationError = ErrorType<void>
    export type CreateFileSharingFileAttachmentMutationVariables = {id: string;data: FileSharingAttachmentRequestInput}

    /**
 * @summary Create File Attachement
 */
export const useCreateFileSharingFileAttachment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFileSharingFileAttachment>>, TError,CreateFileSharingFileAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFileSharingFileAttachment>>,
        TError,
        CreateFileSharingFileAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFileSharingFileAttachmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete File Attachment
 */
export const deleteFileSharingFileAttachment = (
    id: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<DeleteFileSharingFileAttachmentParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<void>(
      {url: `/file_sharing/files/${id}/attachment`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteFileSharingFileAttachmentMutationKey = () => ['deleteFileSharingFileAttachment'] as const;

export const getDeleteFileSharingFileAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>, TError,DeleteFileSharingFileAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>, TError,DeleteFileSharingFileAttachmentMutationVariables, TContext> => {

const mutationKey = getDeleteFileSharingFileAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>, DeleteFileSharingFileAttachmentMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  deleteFileSharingFileAttachment(id,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFileSharingFileAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>>

    export type DeleteFileSharingFileAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteFileSharingFileAttachmentMutationVariables = {id: string;params: DeleteFileSharingFileAttachmentParams}

    /**
 * @summary Delete File Attachment
 */
export const useDeleteFileSharingFileAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>, TError,DeleteFileSharingFileAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>,
        TError,
        DeleteFileSharingFileAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteFileSharingFileAttachmentMutationOptions(options), queryClient);
    }
